import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import routes from 'js/core_pre_webpack/routes';
import { downloadFile } from 'js/citeright/utils/exportCitations';

export async function downloadCitation(
  doi: string,
  format: 'ris' | 'bibtex',
): Promise<void> {
  const response = await fetchWithCsrf(
    routes.journals_article_citation_download_path({
      doi,
      citation_format: format,
    }),
  );
  if (!response.ok) {
    throw new Error(`Failed to export ${format === 'ris' ? 'RIS' : 'BibTeX'}`);
  }
  downloadFile(
    await response.blob(),
    `citation.${format === 'ris' ? 'ris' : 'bib'}`,
    response.headers.get('Content-Disposition'),
  );
}
